import { setFaviconBadgeCountDebounced } from './utils';

export default function NotificationsHelper() {
  // eslint-disable-next-line sonarjs/no-unused-collection
  const notifications = [];

  let notificationsAllowed = false;

  const windowName = 'Connect Chat';

  window.name = windowName;

  const onNotificationsClick = () => {
    window.open('', windowName).focus();
  };

  const checkPermissions = () => {
    if ('Notification' in window) {
      if (Notification.permission === 'granted') {
        notificationsAllowed = true;
        return;
      }

      if (Notification.permission !== 'denied') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            notificationsAllowed = true;
          }
        });
      }
    }
  };

  const create = (title, options) => {
    const notification = new window.Notification(title, options);
    notification.onclick = onNotificationsClick;
    notifications.push(notification);
  };

  const createNotification = (title, options) => {
    if (!notificationsAllowed) {
      checkPermissions();

      if (notificationsAllowed) {
        create(title, options);
      }
    } else {
      create(title, options);
    }
  };

  return {
    checkPermissions,
    createNotification,
  };
}

export const getCpTab = () => {
  let cpTab = document.querySelector('li.connect-chat');
  if (!cpTab) {
    cpTab =
      document.querySelector('li[data-nav-id="KCKC"]') ||
      document.querySelector('li[data-nav-id="KC"]');
  }

  return cpTab;
};

export const setBrowserAndCpTabBadges = (totalUnseenMessages, favIcon) => {
  const cpTab = getCpTab();

  if (cpTab) {
    if (cpTab.style.position !== 'relative') {
      cpTab.style.position = 'relative';
    }

    let badge = document.getElementById('kukui-connect-tab-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.setAttribute('id', 'kukui-connect-tab-badge');
      badge.setAttribute('class', 'menu-red-dot');
      cpTab.appendChild(badge);
    }

    badge.style.display = totalUnseenMessages ? 'inline-flex' : 'none';
  }

  setFaviconBadgeCountDebounced(favIcon, totalUnseenMessages ? ' ' : 0);
};
